/** Materials do not constrain the product category of a sale order. */
export const hasCommonProductCategory = (items: { category?: string; item_type?: string }[]): boolean => {
    const products = items.filter(item => item.item_type !== "material");
    if (!products.length) return true;
    let common = new Set((products[0].category || "").split(";").map(value => value.trim()).filter(Boolean));
    for (const product of products.slice(1)) {
        const categories = new Set((product.category || "").split(";").map(value => value.trim()).filter(Boolean));
        common = new Set(Array.from(common).filter(value => categories.has(value)));
    }
    return common.size > 0;
};
